module.exports = __webpack_public_path__ + "static/media/andie-image-1.e55e16dd.png";